import {resolveHelpURL} from '../../../../utils/url'
import {HINT_CATEGORY, toHintId} from '../Hints.types'
import type {Hint} from '../Hints.types'

import styles from './HintItems.css'

export const headerQueueLinkHint: Hint = {
  id: toHintId('header-queue-number'),
  name: 'Queue size',
  text: 'Shows how many builds are currently queued.',
  category: HINT_CATEGORY.navigation,
  className: styles.headerLink,
  offset: 16,
}
export const headerAgentsLinkHint: Hint = {
  id: toHintId('header-agents-active'),
  name: 'Active agents',
  text: 'Agents are workers that run your builds. This widget shows how many build agents are now installed and running. Hover over the number to see the details.',
  category: HINT_CATEGORY.navigation,
  className: styles.headerLink,
  offset: 16,
  helpLink: resolveHelpURL('?Build+Agent'),
}
export const headerAdministrationLinkHint: Hint = {
  category: HINT_CATEGORY.navigation,
  id: toHintId('header-administration-link'),
  name: 'Administration',
  text: 'In the Administration area, you can manage the global server settings, view server reports, create projects and users, and many more.',
}
export const headerUserProfileLinkHint: Hint = {
  id: toHintId('header-user-menu'),
  name: 'User Menu',
  text: 'The user menu gives quick access to your favorite builds, active investigations, and user settings.',
  category: HINT_CATEGORY.navigation,
  offset: 16,
}
